export default __webpack_public_path__ + "static/media/about-pic.14999a36.png";